import router from '../router'

export class navigationService {

    static homePageName = 'home';
    static documentPageName = 'document';
    static userInfoPageName = 'userInfo';
    static subscriptionInfoPageName = 'subscriptionInfo';
    static archivedPageName = 'archived';
    static proofreadingPageName = 'proofreading';
    static forbiddenPageName = 'forbidden';
    static pageNotFoundPageName = 'pageNotFound';

    static goHomePage() {
        router.push('/')
    }

    static goAnonymousPage() {
        router.push('/anonymous')
    }

    static goForbiddenPage() {
        router.push('/forbidden')
    }

    static goNotFoundPage() {
        router.push('/pageNotFound')
    }

    static goLogoutPage() {
        router.push('/logout')
    }

    static goUserInfoPage() {
        router.push('/user/userInfo')
    }

    static goSubscriptionInfoPag() {
        router.push('/subscriptionInfo')
    }

    static goDocumentPage(documentId: number) {
        router.push(this.getDocumentUrl(documentId))
    }

    static getDocumentUrl(documentId: number) {
        return `/document/${documentId}`;
    }

    static goArchivedDocumentPage(documentId: number) {
        router.push(this.getArchivedDocumentUrl(documentId))
    }

    static getArchivedDocumentUrl(documentId: number) {
        return `/archived-document/${documentId}`;
    }

    static goProofreadingDocumentPage(documentId: number) {
        router.push(this.getProofreadingDocumentUrl(documentId))
    }

    static getProofreadingDocumentUrl(documentId: number) {
        return `/proofreading-document/${documentId}`;
    }
}